import { render, staticRenderFns } from "./worldStock.vue?vue&type=template&id=1c95d220"
import script from "./worldStock.vue?vue&type=script&lang=js"
export * from "./worldStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c95d220')) {
      api.createRecord('1c95d220', component.options)
    } else {
      api.reload('1c95d220', component.options)
    }
    module.hot.accept("./worldStock.vue?vue&type=template&id=1c95d220", function () {
      api.rerender('1c95d220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/worldStock.vue"
export default component.exports